export const ModalConfigData = {
    LANGUAGECHANGE_POPUP: {
        TITLE: "popup_msg.confirmlanguagechange.title",
        DESCRIPTION: "popup_msg.confirmlanguagechange.description"
    },
    LEAVE_POPUP: {
        TITLE: "popup_msg.createpopupdata.title",
        DESCRIPTION: "popup_msg.createpopupdata.description",
    },
    GENRIC_POPUP: {
        TITLE: "popup_msg.order_title"
    },
    ORDERCANCEL_POPUP: {   
        TITLE: "popup_msg.ordercancel.title",
    },
    ORDER_NOT_FOUND:{
        DESCRIPTION: "popup_msg.orderNotFoundKey",
    },
    BUTTONS: {
        BUTTONCANCEL: "popup_msg.confirmlanguagechange.actionbuttoncanceltext",
        BUTTONCONFIRM: "popup_msg.confirmlanguagechange.actionbuttonconfirmtext",
        BUTTONLEAVE: "popup_msg.actionbuttonLeavetext",
        BUTTONBACK: "popup_msg.actionbuttonbacktext",
        BUTTONCLOSE: "popup_msg.actionbuttonclosetext",
        BUTTONOK: "popup_msg.actionbuttonoktext"
    },
    TITLES: {
        ORDERS:"popup_msg.ordertitles.orders",
        ORDERCANCEL: "popup_msg.ordertitles.ordercancel",
        ORDERSEARCH: "popup_msg.ordertitles.ordersearch",
        ORDERSTATUS: "popup_msg.ordertitles.orderstatus",
        ORDERENTRY: "popup_msg.ordertitles.orderentry",
        ORDERVIEW: "popup_msg.ordertitles.orderview",
        ORDERELEASE: "OrderRelease",
        ITEMSEARCH: "Item Search",
        PURCHASEORDERSEARCH: "Purchase Order Search",
        CARRIERSEARCHTITLE : "Registration Search",
        CARRIERSEARCHDESCRIPTION : "We couldn't find the registration you're looking for, please try again after a while or mail to us at customer.support@dhl.com"
    }
}
